import { Box, Button, HStack, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { Image } from "../reusables";
import { Link } from "react-router";
import useProfile from "../../hooks/data/useProfile";
import useReactiveQuery from "../../hooks/data/useReactiveQuery";
import { useEffect } from "react";
import usePosts from "../../hooks/data/usePosts";
import { HiMusicalNote } from "react-icons/hi2";

export default ({ text, validSearchResults }) => {
  const RegularText = (props) => <Text>{props.children}</Text>;

  const ContentView = (props) => {
    // Here, props.children should be a stirng that looks like: @<'user' | 'song'>:<string>, example: @user:aousaf or @song:xxxxxxx
    const [contentType, query] = props.children.replace("@", "").split(":");

    const isValidSearchResult = validSearchResults?.includes(query);

    const { getProfile } = useProfile();
    const { getPost } = usePosts();
    const { get } = useReactiveQuery();
    const profile = query ? get(["profiles", query]) : null;
    const post = query ? get(["posts", query.split("_")[1]]) : null;

    useEffect(() => {
      if (isValidSearchResult) {
        if (contentType === "user") getProfile({ username: query });
        else if (contentType === "song")
          getPost({ userId: query.split("_")[0], postId: query.split("_")[1] });
      }
    }, [props.children]);

    return contentType === "user" ? (
      <Button
        variant={"nav"}
        size="xs"
        leftIcon={
          profile && (
            <Image
              firebaseStoragePath={`photos/${profile.id}/cover/${
                profile.coverPhoto?.[profile.coverPhoto?.length - 1]?.fileName
              }`}
              h="20px"
              w="20px"
              borderRadius={"full"}
            />
          )
        }
        pl="1"
        as={profile && Link}
        to={`/user/${query}`}
      >
        <Text>{profile?.fullName || props.children}</Text>
      </Button>
    ) : (
      <Button
        variant={"nav"}
        size="xs"
        leftIcon={post && <HiMusicalNote />}
        pl="1"
        as={post && Link}
        to={`/user/${post?.user?.username}/post/${post?.id}`}
      >
        <Text>{post?.title || props.children}</Text>
      </Button>
    );
  };

  const parsedElements = useMemo(() => {
    if (!text) return [];

    const parts = [];
    let lastIndex = 0;
    const regex = /@[\w:_]+/g; // Matches @ followed by word characters, colons, or underscores

    text.replace(regex, (match, offset) => {
      // Text before the match
      const before = text.slice(lastIndex, offset);
      if (before) {
        // Split on \n and insert <br />
        const split = before.split(/\n|\\n/);
        split.forEach((chunk, i) => {
          if (i > 0) parts.push(<Box w="full" key={`br-${offset}-${i}`} />);
          if (chunk)
            parts.push(
              <RegularText key={`t-${offset}-${i}`}>{chunk}</RegularText>
            );
        });
      }

      // The match itself
      parts.push(<ContentView key={`u-${offset}`}>{match}</ContentView>);
      lastIndex = offset + match.length;
    });

    // Remaining text after the last match
    const after = text.slice(lastIndex);
    if (after) {
      const split = after.split(/\n|\\n/);
      split.forEach((chunk, i) => {
        if (i > 0) parts.push(<Box w="full" key={`br-end-${i}`} />);
        if (chunk)
          parts.push(<RegularText key={`t-end-${i}`}>{chunk}</RegularText>);
      });
    }

    return parts;
  }, [text, validSearchResults]);

  return (
    <HStack
      w="full"
      h="max-content"
      fontSize={"sm"}
      spacing={"1"}
      flexWrap={"wrap"}
    >
      {parsedElements}
    </HStack>
  );
};
